import React, { useContext } from 'react';

import GqlClientProvider from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/GqlClientProvider';
import FlexCentered from 'components/Common/FlexCentered';
import Typography from 'kingpin/atoms/Typography';
import BaseViewsContext from 'contexts/BaseViewsContext';

import { LeaderboardStep } from './buildSteps';
import DriverLeaderboardContent from './DriverLeaderboardContent';
import ScalingCanvas from './ScalingCanvas';

/*
 * Driver Leaderboard — a bespoke, self-contained wallboard slide. Everything
 * about how this slide looks lives under src/components/DriverLeaderboard, so it
 * can be freely restyled (with AI) without touching any shared dashboard, grid
 * or gadget component. Value formatting flows through the base view
 * (useDriverLeaderboardCells); presentation is entirely our own.
 *
 * The slide eager-loads one grid per configured date range (slide.views) and
 * animates the transition between them — see DriverLeaderboardContent (data +
 * rotation clock) and DriverLeaderboardStage (presentation + motion).
 */

const DriverLeaderboard = ({
  slide,
  pinnedStepIndex,
  onStepsResolved,
}: {
  slide: DriverLeaderboardSlide;
  pinnedStepIndex?: number;
  onStepsResolved?: (steps: LeaderboardStep[]) => void;
}) => {
  const { baseViews } = useContext(BaseViewsContext);
  const parentBaseView = baseViews[slide.dataType];

  if (!parentBaseView || slide.fields.length === 0) {
    return (
      <FlexCentered style={{ width: '100%', height: '100%' }}>
        <Typography.Body type="Body 14" color="var(--color-grey-5)">
          No fields configured
        </Typography.Body>
      </FlexCentered>
    );
  }

  return (
    <GqlClientProvider
      visName={slide.name}
      visId={slide.id}
      visType="driverLeaderboard"
    >
      <ScalingCanvas>
        <DriverLeaderboardContent
          slide={slide}
          parentBaseView={parentBaseView}
          pinnedStepIndex={pinnedStepIndex}
          onStepsResolved={onStepsResolved}
        />
      </ScalingCanvas>
    </GqlClientProvider>
  );
};

export default DriverLeaderboard;
